import {find} from 'lodash'
import {computeUserScore} from '@/services/user'
import {myaxios} from '../helpers/axios-helper'
import {setUpClient} from '../services/app-sync-service'

const baseUrl = process.env.BACKEND_URL

export function getPhotos(store) {
  return myaxios({
    method: 'get',
    url: `${baseUrl}/games/${store.state.game.idGame}/teams/${store.state.team.idTeam}/photos/`,
  }).catch(console.error)
}

export function getChallengesLocations(store) {
  return myaxios({
    method: 'get',
    url: `${baseUrl}/games/${store.state.game.idGame}/teams/${store.state.team.idTeam}/challenges`,
  })
    .then(questions => {
      console.log('locations received:', questions.data)

      store.commit('SET_CHALLENGES_LOCATIONS', questions.data)

      const userScore = computeUserScore(questions.data)
      store.commit('SET_USER_SCORE', userScore)
    })
    .catch(err => {
      console.error(err)
    })
}

export function setPositionToDefaultChallenge(store) {
  const { challengesLocations, userLocation } = store.state
  const challengeToReposition = find(challengesLocations, question => !!question.defaultLocation)

  if (!challengeToReposition) {
    console.log('XX No challenge with defaultLocation')
  } else if (!userLocation || !store.state.isUserAtChallengeLocation) {
    console.log('userLocation', userLocation)
    console.log('store.isUserAtChallengeLocation', store.state.isUserAtChallengeLocation)
    console.log('TOO EARLY !')
  } else {

    // Check if user doesn't already have a challenge close to him
    if (!store.state.isUserAtChallengeLocation.isUserInOneZone) {
      console.log('Reposition default challenge close to user')
      challengeToReposition.location = userLocation
    } else {
      // Keep defaultLocation
      console.log('User already has a challenge close to him, keep defaultLocation')
      challengeToReposition.location = challengeToReposition.defaultLocation
    }

    delete challengeToReposition.defaultLocation
    // Tell backend to store this new challenge location
    setChallengePosition(store, challengeToReposition.challengeId, challengeToReposition.location)
  }

  store.commit('SET_CHALLENGES_LOCATIONS', challengesLocations)
}

function setChallengePosition(store, challengeId, location) {
  myaxios({
    method: 'post',
    url: `${baseUrl}/games/${store.state.game.idGame}/teams/${store.state.team.idTeam}/questions/${challengeId}/location`,
    data: {
      location,
    },
  })
    .then(() => {
      console.log(`Challenge ${challengeId} position successfully saved to backend.`)
    })
    .catch(err => {
      console.error(err)
    })
}

export function unlockQuestion(store, challengeId) {
  return myaxios({
    method: 'put',
    url: `${baseUrl}/games/${store.state.game.idGame}/teams/${store.state.team.idTeam}/questions/${challengeId}/unlock`,
  })
}

export function uploadPicture(store, { challengeId, photo }) {
  return myaxios({
    method: 'put',
    url: `${baseUrl}/games/${store.state.game.idGame}/teams/${store.state.team.idTeam}/photos/${challengeId}/upload`,
    data: {
      photo,
    },
  })
}

export function sendAnswer(store, { challengeId, answer }) {
  return myaxios({
    method: 'post',
    url: `${baseUrl}/games/${store.state.game.idGame}/teams/${store.state.team.idTeam}/questions/${challengeId}/submit`,
    data: {
      answer,
    },
  })
}

export function getTeamLeaderboard(store) {
  return myaxios({
    method: 'get',
    url: `${baseUrl}/games/${store.state.game.idGame}/teamleaderboard`,
  })
}

export function loginTeam(store, teamDetails) {
  store.commit('SET_CONFIG', teamDetails.config)
  store.commit('SET_TENANT', teamDetails.tenant)
  store.commit('SET_TEAM', teamDetails.team)
  store.commit('SET_GAME', teamDetails.game)
  store.commit('SET_QUESTION_RADIUS', teamDetails.game.questionRadius ? teamDetails.game.questionRadius : 80)
  store.commit('SET_API_KEY', teamDetails.authToken.token)
  store.commit('LOGIN', true)
  setUpClient(teamDetails.team.idTeam)
}

export function logoutTeam(store) {
  store.commit('LOGOUT')
  store.commit('SET_CONFIG', null)
  store.commit('SET_TENANT', null)
  store.commit('SET_GAME', null)
  store.commit('SET_TEAM', null)
  store.commit('SET_API_KEY', null)
  store.commit('SET_MAP_ZOOM', null)
  store.commit('SET_MAP_CENTER', null)
  store.commit('SET_CHALLENGES_LOCATIONS', null)
  store.commit('SET_QUESTION_RADIUS', 80)
}



// WEBPACK FOOTER //
// ./src/store/actions.js